import { UpdatePaymentExecutionSepaFileDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { downloadBlob } from 'modules/core/lib/download'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useUpdateSepaFile = () => {
  const [updatePaymenExecutionSepaFile] = useMutation(UpdatePaymentExecutionSepaFileDocument, {
    extractorFn: (data) => data.bankingMutations.updateSepaFileBankingPaymentExecution,
  })

  const updateSepaFile = async (paymentExecutionId: string) => {
    const result = await updatePaymenExecutionSepaFile({
      variables: {
        id: paymentExecutionId,
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('banking.payments.update_sepa_file.error'),
      })
    })
    if (handled.success) {
      if (
        handled.data.paymentExecution?.sepaFile?.url &&
        handled.data.paymentExecution?.sepaFile?.filename
      ) {
        processDownload(
          handled.data.paymentExecution.sepaFile.url,
          handled.data.paymentExecution.sepaFile.filename
        )
      }
    }
  }

  async function processDownload(url: string, filename: string) {
    // cache: 'reload' It was added to fix a bug where the browser was caching the file and not downloading the new one.
    const res = await fetch(url, { credentials: 'include', cache: 'reload' })

    if (!res.ok) {
      throw new Error(`Error fetching ${url}. Status: ${res.status}`)
    }

    const blob = await res.blob()
    downloadBlob(blob, filename)
  }

  return { updateSepaFile, processDownload }
}
